export const UserType = {
    USER_TYPE_LOCAL_AUTHORITY_MANAGER : 1,
    USER_TYPE_DSL : 2,
    USER_TYPE_SYSTEM_ADMIN: 4,
    USER_TYPE_GOVERNOR : 5,
};

export const UserAccountStatus = {
    ACTIVE: 'Y',
    INACTIVE: 'N',
    FAILED: 'F'
}

/* Note these are mirrored in the PHP EstablishmentEndpoint.php */
export const TeacherFilter = {
    ADMIN: 'admin',
    PRIMARY_DSL: 'primary',
    DSL: 'secondary'
}

export const CreateUserResponseCodes = {
    DOES_NOT_EXIST : 0,
    EXISTS_IN_PROVIDER : 1 ,
    EXISTS_IN_OTHER_PROVIDER : 2,
    USER_CREATED_IN_PROVIDER : 3 ,
    USER_CREATED_IN_OTHER_PROVIDER : 4
}

export const AuditReviewStatus =
    {
        NOT_SUBMITTED: 1,       /* Never been submitted - first time required */
        SUBMITTED: 2,           /* Submitted for the first time but not reached review point yet */
        REQUIRES_REVIEW: 3,     /* Submitted, but a review is required now */
        IN_REVIEW: 4,           /* User has reopened for review but has not yet completed */
        REVIEW_SUBMITTED: 5,    /* Has been reviewed and is now up-to-date */
    }

export const AuditQuestionReviewStatus =
    {
        DONE: 0,                /* Never been reviewed */
        IN_REVIEW: 1,           /* Submitted for the first time but not reached review point yet */
        REVIEW_SUBMITTED: 2,     /* Submitted, but a review is required now */
    }

export const ApplicationFeatures =
{
    ADHOC_REOPEN : 'adhoc_reopen'
}